import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import ContactDetails from './edit.user';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Avatar,
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  CircularProgress,
  TableRow,
  Typography,
  makeStyles,
  Button,
} from '@material-ui/core';
import getInitials from '../../utils/getInitials';
import SkeletoLoader from '../../components/skeletoLoader';
import { useNavigate, useParams } from 'react-router-dom';
import firebaseUtility from '../../utils/firebase.utils';

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    marginRight: theme.spacing(2),
  },
  rounded: {
    borderRadius: '15px',
  },
}));

// eslint-disable-next-line max-len
const Results = ({
  className,
  contacts,
  isLoading,
  pageIndex,
  pageSizeIndex,
  setPageSize,
  pageChanged,
  ...rest
}) => {
  const navigate = useNavigate();
  const params = useParams();
  const classes = useStyles();
  const [limit, setLimit] = useState(pageSizeIndex);
  const [page, setPage] = useState(pageIndex);
  const [loading] = useState(isLoading);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [isloading,setIsLoading]=useState(false);


  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPageSize(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage || page);
    pageChanged(newPage || page);
  };

  const getLoadingSkeleton = () => <SkeletoLoader page="contact us"/>;

  const openReportDialog = (report) => {
    navigate(`/app/contact-us/${report.id}`);
  };
  useEffect(() => {
    (async () => {
      if (params.id == null) {
        setOpenDialog(false);
      } else {
        const reportInfo = await firebaseUtility.GetOneDocById(
          'contact-us',
          params.id
        );
        setSelectedReport(reportInfo);
        setOpenDialog(true);
      }
    })();

  }, [params]);
  return (
    <>
      <Card className={clsx(classes.root, className)} {...rest}>
        <PerfectScrollbar>
          <Box minWidth={1050}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Created at</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              {contacts && contacts.length > 0 ?
                <TableBody>
                  {!loading
                   ? contacts.slice(0, limit).map((c) => (
                      <TableRow hover >
                        <TableCell>
                          <Box alignItems="center" display="flex">
                            <Typography color="textPrimary" variant="body1">
                            {c.name}
                            </Typography>
                          </Box>
                        </TableCell>

                        <TableCell>
                          <Box alignItems="center" display="flex">
                            <Typography color="textPrimary" variant="body1">
                            {c.email}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>{c.created &&moment((typeof c?.created === 'string'
                              ? new Date(c.created)
                              : new Date(c.created.toDate().toString())))
                              .format('dddd, MMM DD')}</TableCell>
                        <TableCell>
                          <Button
                            variant="outlined"
                            className={classes.rounded}
                            onClick={() => openReportDialog(c)}
                          >
                            View
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                    : getLoadingSkeleton()}
                </TableBody>
                :
                <TableBody >
                  <TableCell colSpan={3}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}>
                        {isloading?<CircularProgress color='#2c387e' size={30}/>:'No Results Found!'}
                  </div>
                  </TableCell>
                </TableBody>
              }
            </Table>
          </Box>
        </PerfectScrollbar>
        <TablePagination
          component="div"
          count={-1}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleLimitChange}
          page={page}
          rowsPerPage={limit}
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
        />
      </Card>
      {openDialog ? (
        <ContactDetails
          opened={openDialog}
          contact={selectedReport || {}}
          closeDialog={(report) => {
            setOpenDialog(false);
            navigate(`/app/contact-us`);
          }}
        />
      ) : null}
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  contacts: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  setPageSize: PropTypes.func,
  pageChanged: PropTypes.func,
  pageSizeIndex: PropTypes.number,
  pageIndex: PropTypes.number,
};

export default Results;
